import { styled } from "@mui/material/styles";
import { APP_COLOR } from "../../../theme";

export const styles = {
  stepsSnapshot: {
    width: "78vw",
    height: "31vh",
    backgroundColor: "#222222",
    border: "none",
    padding: "0px",
    "&:hover": {
      border: "2px solid #28B6CB",
      backgroundColor: "#333333",
    },
    "&:active": {
      border: "2px solid #28B6CB",
      backgroundColor: "#333333",
    },
  } as const,
  cell: {
    backgroundColor: "#202121",
    textAlign: "center",
    color: "white",
    width: "100%",
    height: "2.5vh",
    border: "1px solid #303030",
    borderRadius: 0,
  } as const,
};

interface ItemProps {
  notesSize: number;
  isClicked?: boolean;
  trackSelected: boolean;
}

export const Item = styled("div", {
  shouldForwardProp: (prop) =>
    !["notesSize", "isClicked", "trackSelected"].includes(prop as string),
})<ItemProps>(({ notesSize, isClicked, trackSelected }) => ({
  backgroundColor: isClicked ? APP_COLOR : trackSelected ? "#333333" : "#202121",
  textAlign: "center",
  color: "white",
  width: "100%",
  height: `${31 / notesSize}vh`,
  borderRight: "1px solid #303030",
  borderLeft: "1px solid #303030",
  borderTop: "none",
  borderBottom: "none",
  borderRadius: 0,
}));
